module.exports = __webpack_public_path__ + "img/infoGraphic-nopic.1dbfe6ac.png";